// @flow

export const printer = {
    debug: (title: string, msg: string, /* eslint-disable */logger: (string, ...params: string[]) => void = console.log/* eslint-enable */) => {
        const headerStyle = "background-color: red; color: white; font-size: 1.1em; font-weight: bold; padding: 3px 10px; border-radius: 5px"
        const titleStyle = "color: #444; font-weight: bold; font-size: 1.1em"
        const msgStyle = "color: #222; font-weight: bold"

        logger(`%cDEBUG%c ${title}`, headerStyle, titleStyle)
        logger(`%c${msg}`, msgStyle)
    }
}


// WEBPACK FOOTER //
// ./src/tools/printer.js